import { node } from "~/util/dom";

export default function createLinkButton({
	className = "",
	type = "button",
	...props
}: Partial<HTMLButtonElement>): HTMLButtonElement {
	return node("button", {
		className: `ui-linkbutton ${className}`,
		type,
		...props,
	});
}
